<template>
	<div :class="[ask.no?'check_choose borTop':'check_choose']">
		<div :class="[Number(number)||Number(number)===0?'choose_title padding':'choose_title']">
			<p v-html="ask.question_title" v-if="ask.question_title"></p>
			<p :class="{'stem':ask.question_title}" v-if="ask.content" v-html="ask.content"></p>
			<p v-if="ask.image"><img :src="ask.image"></p>
			<span class="tit_num" v-if="Number(number)">{{number}}、</span>
			<span class="tit_num" v-else-if="Number(number)===0">{{ask.no}}、</span>
		</div>
		<div class="showBtn" @click="showBtn" v-if="mytask!=1">{{showBtnCon}}<i :class="{'icon_bottom':!chooseShowBtn,'icon_top':chooseShowBtn}"></i></div>
		<template v-if="!!checked">
			<div :class="[item_sub.option===ask.user_answer?'choose_opation inspect_myColor clearfix':'choose_opation clearfix']" v-for="(item_sub,index_sub) in ask.options" v-if="chooseShowBtn&&type!=7">
				<i class="option" v-html='item_sub.option'></i>
				<span style="background: transparent;" v-html='item_sub.content'></span>
				<p class="choose_img_pic" v-if="item_sub.image">
					<img :src="item_sub.image" alt="">
				</p>
			</div>
		</template>
		<template v-else>
			<div :class="[item_sub.is_right?'choose_opation active clearfix':'choose_opation clearfix']" v-for="(item_sub,index_sub) in ask.options" v-if="chooseShowBtn">
				<i class="option" v-html='item_sub.option'></i>
				<span style="background: transparent;" v-html='item_sub.content'></span>
				<p class="choose_img_pic" v-if="item_sub.image">
					<img :src="item_sub.image" alt="">
				</p>
			</div>
		</template>
		<div :class="[myColor?'refer_inspect_myColor':'refer_sentence']" v-if="type==7">
			参考答案：
			<div v-html="ask.refer" v-if="ask.refer"></div>
		</div>
	</div>
</template>

<script type="text/ecmascript-6">

	export default {
		data() {
			return {
				showBtnCon:'展开选项',
				chooseShowBtn:false,
			}
		},
		components: {

		},
		props: ['ask', 'type', 'number','mystatus',"checked",'myColor'],
		//mystatus 1是教师检查作业 展开选项不显示
		computed:{
			mytask(){
				return this.mystatus?1:0;
			}
		},
		methods: {
			showBtn(){
				this.chooseShowBtn = !this.chooseShowBtn;
				if(this.chooseShowBtn){
					this.showBtnCon = '收起选项';
				}else{
					this.showBtnCon = '展开选项';
				}
			},
		},
		created() {
			if(this.mytask == 1){
				this.chooseShowBtn = true;
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@import "./src/assets/scss/common/_mixin";

	.check_choose {
		&.borTop {
			border-top: 1px/$ppr solid #E8E8E8;
		}
		.choose_title {
			p {
				padding: 32px/$ppr 24px/$ppr;
				border-top: 1px/$ppr solid #E8E8E8;
				word-break: break-word;
				word-wrap: break-word;
				&:first-child {
					border-top: none;
				}
			}
			&.padding {
				position: relative;
				.tit_num {
					position: absolute;
					top: 32px/$ppr;
					left: 24px/$ppr;
				}
				p:first-child {
					padding-left: 80px/$ppr;
				}
			}
		}
		.stem {
			line-height: 50px/$ppr;
			border-top: 1px/$ppr solid #E8E8E8;
		}
		.choose_opation {
			position: relative;
			padding: 32px/$ppr 24px/$ppr 32px/$ppr 96px/$ppr;
			border-top: 1px/$ppr solid #E8E8E8;
			&.inspect_myColor{
				color: #fff;
				.option {
					background: #5d89ef;
				}
				span {
					color: #5d89ef;
				}
			}
			&.active {
				color: #fff;
				.option {
					background: #66cc22;
				}
				span {
					color: #66cc22;
				}
			}
			.option {
				display: block;
				position: absolute;
				top: 50%;
				left: 24px/$ppr;
				margin-top: -24px/$ppr;
				width: 48px/$ppr;
				height: 48px/$ppr;
				line-height: 48px/$ppr;
				text-align: center;
				border-radius: 48px/$ppr;
				border: 1px/$ppr solid #E8E8E8;
			}
		}
		.refer_sentence {
			padding: 32px/$ppr 24px/$ppr;
			color: #66cc22;
			border-top: 1px/$ppr solid #E8E8E8;
		}
		.refer_inspect_myColor{
			padding: 32px/$ppr 24px/$ppr;
			color: #5d89ef;
			border-top: 1px/$ppr solid #E8E8E8;
		}
	}
	.showBtn{
		border-top: $line 1px/$ppr solid;
		line-height:96px/$ppr;
		height:96px/$ppr;
		color:#5e89ef;
		font-size:30px/$ppr;
		padding-left:40px/$ppr;
		position:relative;
		i{
			display:block;
			width:25px/$ppr;
			height:13px/$ppr;
			position:absolute;
			top:42px/$ppr;
			left:170px/$ppr;
		}
		.icon_bottom{
			background:url('./img/icon_open.png')0 0 no-repeat;
			background-size:100% 100%;
		}
		.icon_top{
			background:url('./img/icon_close.png')0 0 no-repeat;
			background-size:100% 100%;
		}
	}
</style>
